import Box, {BoxProps} from '@mui/material/Box';

import {useResponsive} from 'src/hooks/use-responsive';

import {useSettingsContext} from 'src/minimal-components/settings';

import {NAV, HEADER} from '../config-layout';
import backgroundImage from 'src/assets/images/low_res_background_light.png';
import { environment } from '@shared/config/environment';

// ----------------------------------------------------------------------

const SPACING = 8;

export default function Main({children, sx, ...other}: BoxProps) {
  const settings = useSettingsContext();

  const lgUp = useResponsive('up', 'lg');

  const isNavHorizontal = settings.themeLayout === 'horizontal';

  const isNavMini = settings.themeLayout === 'mini';

  if (isNavHorizontal) {
    return (
      <Box
        component="main"
        sx={{
          minHeight: 1,
          display: 'flex',
          flexDirection: 'column',
          pt: `${!environment?.IS_LMS_ENABLED_FOR_EXTERNAL_SITE_AS_EMBEDDED ? HEADER.H_MOBILE + 24:12}px`,
          pb: 10,
          ...(lgUp && {
            pt: `${!environment?.IS_LMS_ENABLED_FOR_EXTERNAL_SITE_AS_EMBEDDED ? HEADER.H_MOBILE * 2 + 40:12}px`,
            pb: 15
          }),
          backgroundImage: `${!environment?.IS_LMS_ENABLED_FOR_EXTERNAL_SITE_AS_EMBEDDED ? `url(${backgroundImage})`:''}`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundAttachment: 'fixed'
        }}>
        {children}
      </Box>
    );
  }

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        minHeight: 1,
        display: 'flex',
        flexDirection: 'column',
        py: `${HEADER.H_MOBILE + SPACING}px`,
        ...(lgUp && {
          px: 2,
          py: `${HEADER.H_DESKTOP + SPACING}px`,
          width: `calc(100% - ${NAV.W_VERTICAL}px)`,
          ...(isNavMini && {
            width: `calc(100% - ${NAV.W_MINI}px)`
          })
        }),
        backgroundImage: `${!environment?.IS_LMS_ENABLED_FOR_EXTERNAL_SITE_AS_EMBEDDED ? `url(${backgroundImage})`:''}`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundAttachment: 'fixed',
        ...sx
      }}
      {...other}>
      {children}
    </Box>
  );
}

